import 'core-js/es'
import 'public-path'
import 'es6-promise/auto'
import React from 'react'
import ReactDOM from 'react-dom'
import { readableAppVersion } from 'phonecom'
import './index.css'
import App from './components/App'
import { RenderOptions } from './types'
import setAppConfigUrlFromCurrentScript from './appConfigUrl'

setAppConfigUrlFromCurrentScript()

/**
 *
 */
export { usePasswordManagerAppContext } from './components/PasswordManagerAppProvider'

const getContainer = (renderId: string) => {
    const container = document.getElementById(renderId)
    if (!container) {
        throw new Error(`pdcPasswordManager: can not find container element with ID: ${renderId}`)
    }
    return container
}

const pdcPasswordManagement = {
    render: (options: RenderOptions & { renderId: string }) => {
        const container = getContainer(options.renderId)
        ReactDOM.render(<App options={options} />, container)
    },
    unmount: (renderId: string) => {
        const container = getContainer(renderId)
        ReactDOM.unmountComponentAtNode(container)
    },
    version: readableAppVersion()
}

export default pdcPasswordManagement
